import {Anchor} from 'src/design/atoms/Anchor';
import {Box} from 'src/design/atoms/Box';
import {Text} from 'src/design/atoms/Text';
import React from 'react';
import {Link} from 'react-router-dom';
import type {UserGroupSimpleResponse} from 'src/api/ProactApiClient';
import {PathUtility} from 'src/shared/constants/PathBuilder';

export interface UserGroupMembershipsProps {
  groups?: UserGroupSimpleResponse[];
}

export const UserGroupMemberships: React.FC<UserGroupMembershipsProps> = ({
  groups,
}) => {
  if (!groups || groups.length === 0) {
    return (
      <Text size="xs" c="dimmed">
        No user group memberships found.
      </Text>
    );
  }

  return (
    <>
      {groups.map(group => (
        <Box key={group.id} mb="md">
          <Anchor
            component={Link}
            to={PathUtility.UserGroupView(group.id, 'module-permissions')}
            target="_blank"
            size="sm"
            c="dimmed">
            → {group.name}
          </Anchor>
        </Box>
      ))}
    </>
  );
};
